<template>
<cPaymentStatus :paymentStatus="page"/>

</template>

<script>

import {mapGetters, mapActions} from "vuex";
import Vue from 'vue';
import { COMPONENT_NAME, PATHNAME,ROUTER_PARAM, PAYMENT_PROCEED_TO} from "../../../../util/constants";
import router, { navigate, goBack } from "../../../../router/index";
import Logger from "../../../../services/logger";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../../config/API_DATA";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import BaseConfiguration from "../../../../config/base";
import {handleJWT,getErrorAlertValue,addClassToBody,removeClassBody} from "../../../../util/util";
import cPaymentStatus from "../../../../components/payment/cPaymentStatus";

export default {
   name:COMPONENT_NAME.SUCCESS_PAY,
    components: {
    cPaymentStatus,
   
  },
    data() {
    return {
     page:PAYMENT_PROCEED_TO.SUCCESS_PAGE,
     token:null,
    }},
    computed: { 
        //  ...mapGetters("sPaymentStatus", {
        //      GET_RECHARGE_DET_RES: "GET_RECHARGE_DET_RES",
            
        //     }),
            
        },

 
        
    methods:{
      
    
    },
         

     beforeCreate() {    
   addClassToBody(COMPONENT_NAME.SUCCESS_PAY);
  },
  
   beforeDestroy() {
             this.$root.$emit("toggle-sidebar-minimize", true);

       removeClassBody();
    },
}
</script>